import { createFileRoute } from '@tanstack/react-router';
import SharedRequestView from './SharedRequestView';

export const Route = createFileRoute('/share/r/$token')({
  component: () => {
    const { token } = Route.useParams();
    return <SharedRequestView token={token} />;
  },
});
